import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateMaintenanceServiceTags } from '../../api/maintenance-service.ts';
import { UpdateMaintenanceServiceTagsRequest } from '../../api/requests/maintenance-service-request.ts';

export default function useUpdateMaintenanceServiceTags(): UseMutationResult<
  Awaited<ReturnType<typeof updateMaintenanceServiceTags>>,
  Error,
  UpdateMaintenanceServiceTagsRequest
> {
  return useMutation({
    mutationFn: updateMaintenanceServiceTags,
  });
}
